var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 0C0.976 0 0.140437 0.772625 0.0234375 1.76562L10 8L19.9766 1.76562C19.8596 0.772625 19.024 0 18 0H2ZM0 3.75195V14C0 15.105 0.895 16 2 16H18C19.105 16 20 15.105 20 14V3.75195L10.5293 9.66992C10.2053 9.87192 9.7947 9.87192 9.4707 9.66992L0 3.75195Z",
    fill: "inherit",
    fillOpacity: 0.88
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.7d74fcd58d1cc4b4cab54e47f6d8c313.svg";
export { ForwardRef as ReactComponent };